export const kColors = {
  backgroundGrey: "#fafafa",
  black: "#000",
  brandPink: "rgb(237, 212, 203)",
  brandLight: "rgb(243, 242, 238)",
  brandDarkGreen: "rgb(44, 75, 70)",
  brandDarkGreenHover: "rgb(36, 63, 58)",
  brand200: "#9B9C9B",
  brand300: "#9B9C9C",
  brand400: "#5D5F5E",
  brand500: "#373938",
  brandDark: "#373938",
  brandDark100: "rgba(55, 57, 56, 0.8)",
  brandDark200: "rgba(55, 57, 56, 0.2)",
  brandDark300: "#B9BAB9",
  brandDarkTransparent: "#37393833",
  secondaryRed: "#C55462",
  secondaryOrange: "#EB896A",
  secondaryYellow: "#F8D16E",
  secondaryGreen: "#11A16D",
  secondaryGray: "#9A969C",
  lightBlack: "rgba(0, 0, 0, .1)",
  darkGray: "#4F4F4F",
  almostWhite: "rgb(250, 250, 250)",
  lightGray: "#f5f5f5",
  white: "#fff",
  errorGrey: "#F7F9F8",
  transparentWhite: "rgba(255, 255, 255, .8)",
  transparentGray: "rgba(169, 169, 169, 0.7)",
  orange200: "#F9C06B",
  red200: "#FB8C8C",
  red: "rgb(216, 108, 112)",
  redLight: "rgb(255, 221, 221)",
  gray: "gray",
  gray50: "#F8F7F5",
  gray100: "#EEECED",
  gray300: "#D7D7D7",
  gray400: "#C4C4C4",
  gray500: "#9B9C9C",
  gray600: "#819390",
  mediumGrey: "rgb(169, 169, 169)",
  green100: "#4dd2be",
  green200: "#93EB85",
  green500: "#5D716E",
  green: "rgb(86, 184, 112)",
  greenLight: "rgb(237, 255, 240)",
  yellow200: "#F4E76A",
  yellow: "rgb(207, 165, 41)",
  yellowLight: "rgb(255, 246, 215)",
  blue: "blue",
  testGreen: "rgb(200,255,0)",
  transparent: "rgba(0, 0, 0, 0)",
  lightMed: "#E0E0E0",
  VeryLightGrey: "#F1F1F1",
  brandCoral: "#D89F8B",
  brandGreen400: "#415D59",
  brandGreen: "#2C4B46",
  brandPurple: "#63424B",
  brandPink2: "#E0D9DB",
  transparentBlack: "#0006",
  giftedChatBlue: "#398AE5",
  giftedChatBlueLight: "#7db2ee",
  slightTransparent: "#00000080",
  notificationShadowColor: "#00000020",
  grayPink: "#E0D9DB",
  pink: "#F9BDEF",
  brandDarkRed500: "rgba(99, 66, 75, 0.5)",
  brandDarkRed: "#63424B",
  lightBrand: "#F3F2EE",
  snackbar: "rgb(38, 38, 38)",
};
